export default __webpack_public_path__ + "6530043ce8bbdcf7eee74464dfe33210.png";